import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { PointsOfInterest } from './types'
import { RootState } from '../types'

export const state: PointsOfInterest = {
  pointsOfInterest: JSON.parse(localStorage.getItem('pointsOfInterestSelectedLt') || '[]'),
  filteredPointsOfInterest: [],
  pointsOfInterestOnMap: [],
  showPointsOfInterestLoadingButton: false
}

const namespaced = true

export const pointsOfInterestState: Module<PointsOfInterest, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
